<div class="message-tip-wrapper tip-{{type}}" [class.simple-mode]="simpleMode" *ngIf="showMessageTip">
    <div class="icon-wrapper" [class.simple-mode]="simpleMode" [ngSwitch]="type">
        <svg *ngSwitchCase="'info'">
            <use [attr.xlink:href]="simpleMode ? '#core-icon-simple-status-info' : '#icon-alarms-warning'"></use>
        </svg>
        <svg *ngSwitchCase="'error'">
            <use [attr.xlink:href]="simpleMode ? '#core-icon-simple-status-failed' : '#icon-status-failed'"></use>
        </svg>
        <svg *ngSwitchCaseDefault>
            <use [attr.xlink:href]="simpleMode ? '#core-icon-status-warning' : '#icon-alarms-warning'"></use>
        </svg>
    </div>
    <div class="message-text-wrapper" *ngIf="contentHandler && contentHandler.length">
        <ng-container *ngFor="let content of contentHandler; let i=index;">
            <a *ngIf="content.handler"
                herf="javascript:void(0);"
                (click)="content.handler()"
            >{{content.text}}</a>
            <a *ngIf="content.link" [id]="'content-link' + i" [href]="content.link" target="_blank">{{content.text}}</a>
            <ng-container *ngIf="!content.handler && !content.link">{{content.text}}</ng-container>
        </ng-container>
        <span
            class="message-close-wrapper"
            (click)="onCloseClick()"
            *ngIf="showCloseBtn">
            &times;
        </span>
    </div>
    <div class="message-text-wrapper" *ngIf="!contentHandler">
        <span class="message-text">{{messageTip.content}}</span>
        <span *ngFor="let btn of messageTip.handler">
            <a class="message-link"
            herf="javascript:void(0);"
            (click)="btn.onClick($event)"
            >{{btn.text}}</a>
        </span>
        <span
            class="message-close-wrapper"
            (click)="onCloseClick()"
            *ngIf="showCloseBtn">
            &times;
        </span>
    </div>
</div>
